import React from 'react';
import { BodyText, Button, Grid, SpaceWrapper } from 'ui-toolkit';

interface IDeleteContactWarningProps {
  onCancel: () => void;
  onDelete: (contactId: string) => void;
  contactId: string;
  contactName: string;
}
export const DeleteContactWarning: React.FC<IDeleteContactWarningProps> = ({
  onCancel,
  onDelete,
  contactId,
  contactName,
}) => (
  <SpaceWrapper>
    <Grid textAlign={'center'}>
      <BodyText>{`Are you sure you want to remove ${contactName} as a contact for this order? They will be removed from all functions to which they are assigned.`}</BodyText>
      <Grid columnCount={2}>
        <Button intent={'danger'} type={'button'} onClick={() => onDelete(contactId)}>
          Yes
        </Button>
        <Button intent={'secondary'} type={'button'} onClick={onCancel}>
          No
        </Button>
      </Grid>
    </Grid>
  </SpaceWrapper>
);
